module.exports = __webpack_public_path__ + "media/images/wedding/top/wedding-top-main-6780230f77d572592669cbe0a749dcf0.jpg";